import { createLightTheme, createDarkTheme, BrandVariants } from "@fluentui/react-components";

const paebblBrand: BrandVariants = {
  10: "#050709",
  20: "#101820",
  30: "#1e2a33",
  40: "#2c3d47",
  50: "#3b515c",
  60: "#4b6672",
  70: "#5c7c89",
  80: "#6e93a0",
  90: "#98a2a0",
  100: "#a8b2b0",
  110: "#b8c2c0",
  120: "#c8d2d0",
  130: "#dce6e4",
  140: "#e8f0ee",
  150: "#f4f8f7",
  160: "#ffffff",
};

export const paebblLightTheme = {
  ...createLightTheme(paebblBrand),
  colorBrandBackground: "#faaf3b",
  colorBrandForeground1: "#faaf3b",
  colorNeutralBackground1: "#ffffff",
  colorNeutralForeground1: "#101820",
  colorStatusSuccessBackground1: "#1e8387",
  colorStatusDangerBackground1: "#973b26",
  colorStatusWarningBackground1: "#b45236",
};

export const paebblDarkTheme = {
  ...createDarkTheme(paebblBrand),
  colorBrandBackground: "#faaf3b",
  colorNeutralBackground1: "#101820",
  colorNeutralForeground1: "#ffffff",
  fontFamilyBase: "DenimInkRegular, 'Segoe UI', sans-serif",
};

/** Shared palette constants for use in makeStyles and inline styles. */
export const palette = {
  copperRust: "var(--palette-secondary-copper-rust)",
  mineralTeal: "var(--palette-tertiary-mineral-teal)",
  oceanSlate: "var(--palette-tertiary-ocean-slate)",
  darkBase: "var(--palette-primary-carbon-black)",
  white: "var(--palette-primary-white)",
  paleGraphite: "var(--palette-primary-pale-graphite)",
  platinum: "var(--palette-primary-platinum)",
  error: "var(--palette-secondary-terracotta-clay)",
  cardBg: "#1e2a33",
  cardHover: "#2c3d47",
  border: "#4b6672",
  radiusSmall: "var(--corner-radius-extra-small)",
  radiusMedium: "var(--corner-radius-small)",
  radiusLarge: "var(--corner-radius-medium)",
  radiusPill: "9999px",
} as const;
